import React, { useEffect, useState } from 'react'
import MySelect from '../../../UI/form/MySelect'
import { getGoodInBoxAPI } from '../../../../api/products/goodAPI'
import { useDispatch } from 'react-redux'
import { setBoxGoodId } from '../../../../store/boxSlice'

const BoxOneFieldGoodSelect = ({ boxId, required, setValidate, setValueForm, forciblyValue }) => {

	const dispatch = useDispatch()

  	const [value, setValue] = useState(forciblyValue)
	const [goods, setGoods] = useState([])

	useEffect(() => {
		getGoods()
	}, [])

	useEffect(() => {
		setValueDefault()
	}, [goods])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoods = () => {
		// dispatch(setBoxGoodId(null))
		getGoodInBoxAPI({ boxId }).then(data => {
			setGoods(data)
		}).catch(e => {
			// setError(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

	const setValueDefault = () => {
		if (goods.length > 0) {
			setValue(goods[0].id)
			setValueForm(goods[0].id)
			// dispatch(setBoxGoodId(goods[0].id))
		}
	}

  return (
    <MySelect
        value={value}
        label="Товар в коробці"
        labelId="select__good-label"
        id='select__good'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Товар в коробці'
        // sx={{width: '200px'}}
        options={
			goods && goods.length > 0 ? 
				goods.map(good => {
            		return {id: good.id, name: good.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default BoxOneFieldGoodSelect